export default __webpack_public_path__ + "static/media/AntyLucy_1.87d26b6f.jpg";